import React from 'react';
import _ from 'lodash';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid';

const Pagination = ({
  dropdown,
  page: currentPage,
  sizePerPage,
  sizePerPageList,
  dataSize,
  onPageChange,
  onSizePerPageChange,
}) => {
  // Create an array of pages based on data size and page size
  const pages = _.range(1, Math.ceil(dataSize / sizePerPage) + 1);

  // Calculate results being shown on current page
  const from = currentPage * sizePerPage - sizePerPage + 1;
  const to =
    currentPage * sizePerPage > dataSize ? dataSize : currentPage * sizePerPage;

  return dataSize > 0 ? (
    <div className="bg-white px-4 py-8 flex items-center justify-between sm:px-4 ">
      {dropdown ?? <div>{dropdown}</div>}
      <select
        id="location"
        name="location"
        value={sizePerPage}
        onChange={(e) => onSizePerPageChange(e.target.value, currentPage)}
        className="mr-2 pl-4 pr-11 py-1.5 text-base border-gray-300 focus:outline-none focus:ring-red-300 focus:border-red-300 sm:text-sm rounded-2xl"
      >
        {sizePerPageList.map((num, i) => (
          <option key={i} value={num}>
            {num}
          </option>
        ))}
      </select>
      <div className="flex-1 flex justify-between sm:hidden">
        <button
          className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
          disabled={currentPage === 1 ? true : false}
          onClick={() => {
            onPageChange(parseInt(currentPage) - 1);
          }}
        >
          Previous
        </button>
        <button className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
          Next
        </button>
      </div>
      <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-700 font-inter">
            Showing <span className="font-medium">{from}</span> to{' '}
            <span className="font-medium">{to}</span> of{' '}
            <span className="font-medium">{dataSize}</span> results
          </p>
        </div>
        <div>
          <div
            className="relative z-0 inline-flex rounded-2xl shadow-sm -space-x-px"
            aria-label="Pagination"
          >
            <button
              className="relative inline-flex items-center px-2 py-1.5 rounded-l-2xl border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:bg-gray-200"
              disabled={currentPage == 1}
              onClick={() => {
                onPageChange(parseInt(currentPage) - 1);
              }}
            >
              <span className="sr-only">Previous</span>
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
            </button>

            <div
              aria-current="page"
              className="bg-white border-gray-300 text-gray-500 font-inter relative inline-flex items-center px-4 py-1.5 border-t border-b text-xs font-medium"
            >
              {currentPage} of {pages.length}
            </div>

            <button
              className="relative inline-flex items-center px-2 py-1.5 rounded-r-2xl border-t border-b border-r border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50"
              disabled={currentPage == pages.length}
              onClick={() => {
                onPageChange(parseInt(currentPage) + 1);
              }}
            >
              <span className="sr-only">Next</span>
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <>&nbsp;</>
  );
};

export default Pagination;
